import { render } from "./AddCodificationModal.vue?vue&type=template&id=292a9768&ts=true"
import script from "./AddCodificationModal.vue?vue&type=script&lang=ts"
export * from "./AddCodificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__